import type { EnterResponse } from '@app/shared';

/** What the screen of a person without access shows after asking to enter (spec 9.1). */
export type EntryView =
  | { kind: 'reload' }
  | { kind: 'welcome'; credits: number; firstReel: boolean }
  | { kind: 'full' }
  | { kind: 'closed' }
  | { kind: 'error' };

export function entryView(r: EnterResponse | 'error'): EntryView {
  if (r === 'error') return { kind: 'error' };
  switch (r.kind) {
    case 'has_access':
      return { kind: 'reload' };
    case 'entered':
      return { kind: 'welcome', credits: r.credits, firstReel: r.firstReel };
    case 'full':
      return { kind: 'full' };
    case 'closed':
      return { kind: 'closed' };
  }
}
